import React from 'react';
import { XIcon } from 'lucide-react';
const pains = ['Writing every practice plan yourself, on unpaid hours your stipend never covered', 'Half the team standing around while one stunt group works', 'No clear order for progressions, so you guess what comes after what', 'Groups that hit every stunt at practice and drop it at comp', 'Inheriting the team at the last minute with tryouts already on the calendar', 'Parents questioning placements you have no documentation for', 'Scrolling YouTube at 11pm looking for drills you can actually teach', 'Wearing thin before the season is even halfway done'];
export function PainGrid() {
  return <section aria-labelledby="pain-heading" className="w-full bg-navy-deep" data-id="element-126" data-mp="1brnvrsas2sn1">
      <div className="max-w-5xl mx-auto px-5 py-16 sm:py-20" data-id="element-127" data-mp="17qc4zjg641d9">
        <div className="text-center" data-id="element-128" data-mp="362khgqavx9kb">
          <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-gold" data-id="element-129" data-mp="361j5mjm1oj1j">
            The coaching reality
          </p>
          <h2 id="pain-heading" className="mt-3 font-display font-bold uppercase text-white text-3xl sm:text-4xl md:text-5xl leading-tight" data-id="element-130" data-mp="3g8k2ndk0qcpk">
            If you coach cheer, you know at least{' '}
            <span className="text-crimson-soft" data-id="element-131" data-mp="379q95w1zi2g8">half of this list.</span>
          </h2>
        </div>

        <ul className="mt-9 grid gap-3 text-left sm:grid-cols-2 sm:gap-x-5" data-id="element-132" data-mp="3bas4i1ss5ucx">
          {pains.map(pain => <li key={pain} className="flex items-start gap-3 rounded-xl border border-navy-line bg-navy-card px-4 py-4 text-sm text-white/85" data-id="element-133" data-mp="2uyve80s3l5w">
              <span className="mt-0.5 flex h-5 w-5 flex-none items-center justify-center rounded-full bg-crimson/20" data-id="element-134" data-mp="3q6hnrs6kztdy">
                <XIcon className="h-3 w-3 text-crimson-soft" aria-hidden="true" data-id="element-135" data-mp="3u71kwvr5mx03" />
              </span>
              {pain}
            </li>)}
        </ul>

        <p className="mt-9 text-center font-display uppercase text-2xl sm:text-3xl text-gold leading-tight" data-id="element-136" data-mp="qlm8r8tgr2zu">
          How many more practices do you want to improvise?
        </p>
      </div>
    </section>;
}